// Shared formatting for a refine turn that carries a highlighted excerpt. The excerpt is embedded as
// a markdown blockquote above the instruction. This MUST match the backend's composeRefineMessage so
// the optimistic turn and the persisted turn render identically.
export function formatRefineUserMessage(instruction: string, excerpt?: string): string {
  if (!excerpt) return instruction
  const quoted = excerpt
    .split('\n')
    .map((line) => `> ${line}`)
    .join('\n')
  return `${quoted}\n\n${instruction}`
}

// Inverse of formatRefineUserMessage: pulls a leading blockquote (the quoted excerpt) off the front
// of a user turn so it can be rendered distinctly from the instruction. Returns quote: null when the
// turn has no leading blockquote.
export function splitQuotedInstruction(content: string): { quote: string | null; body: string } {
  const lines = content.split('\n')
  const quoteLines: Array<string> = []
  let i = 0
  for (; i < lines.length; i++) {
    const line = lines[i]
    if (line === undefined || !line.startsWith('> ')) break
    quoteLines.push(line.slice(2))
  }
  if (quoteLines.length === 0) return { quote: null, body: content }
  if (lines[i] === '') i++
  return { quote: quoteLines.join('\n'), body: lines.slice(i).join('\n') }
}
